// extracted by mini-css-extract-plugin
export default {"container":"Users_container__vQvgA","avatar":"Users_avatar__fv0G6","username":"Users_username__mqjoW","userCard":"Users_userCard__wNYb2"};